var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoiteringNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E2FCFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8149 23.3337L16.2223 20.9633L15.0371 19.1855V15.63M15.0371 15.63L12.6667 17.4077L13.2593 18.5929M15.0371 15.63L16.8149 16.8151L18.0001 17.1114M14.4445 20.9633L13.2593 23.3337M14.4445 13.2596C14.4445 13.4168 14.507 13.5675 14.6181 13.6786C14.7292 13.7897 14.88 13.8522 15.0371 13.8522C15.1943 13.8522 15.345 13.7897 15.4561 13.6786C15.5673 13.5675 15.6297 13.4168 15.6297 13.2596C15.6297 13.1024 15.5673 12.9517 15.4561 12.8406C15.345 12.7294 15.1943 12.667 15.0371 12.667C14.88 12.667 14.7292 12.7294 14.6181 12.8406C14.507 12.9517 14.4445 13.1024 14.4445 13.2596Z",
    stroke: "#017C84",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1481 23.3337L21.5556 20.9633L20.3704 19.1855V15.63M20.3704 15.63L18 17.4077L18.5926 18.5929M20.3704 15.63L22.1481 16.8151L23.3333 17.1114M19.7778 20.9633L18.5926 23.3337M19.7778 13.2596C19.7778 13.4168 19.8402 13.5675 19.9513 13.6786C20.0625 13.7897 20.2132 13.8522 20.3704 13.8522C20.5275 13.8522 20.6783 13.7897 20.7894 13.6786C20.9005 13.5675 20.963 13.4168 20.963 13.2596C20.963 13.1024 20.9005 12.9517 20.7894 12.8406C20.6783 12.7294 20.5275 12.667 20.3704 12.667C20.2132 12.667 20.0625 12.7294 19.9513 12.8406C19.8402 12.9517 19.7778 13.1024 19.7778 13.2596Z",
    stroke: "#017C84",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoiteringNotifications);
export default __webpack_public_path__ + "static/media/loitering-notifications.2ce2f98d9a0e10b8974072420418d5a0.svg";
export { ForwardRef as ReactComponent };